import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Search as SearchIcon } from '@mui/icons-material';
import { TextInput, GlobalButton } from '@/components';
import type { ScannedCodeMode } from '@/utils/scannedCode';
import { useState } from 'react';

interface ShippingSearchInputProps {
  onSearch: (shippingNumber: string) => void;
  isLoading: boolean;
  defaultValue?: string;
  mode?: ScannedCodeMode;
  onModeChange?: (mode: ScannedCodeMode) => void;
}

const SEARCH_MODES: { value: ScannedCodeMode; label: string; placeholder: string }[] = [
  { value: 'NUMBER', label: 'Nº de pedido', placeholder: 'Ingrese el número del pedido' },
  {
    value: 'COMMERCIAL_NUMBER',
    label: 'Código externo',
    placeholder: 'Ingrese el código externo del comercio',
  },
];

const ShippingSearchInput = ({
  onSearch,
  isLoading,
  defaultValue = '',
  mode = 'NUMBER',
  onModeChange,
}: ShippingSearchInputProps) => {
  const [value, setValue] = useState(defaultValue);
  const placeholder =
    SEARCH_MODES.find((option) => option.value === mode)?.placeholder ??
    SEARCH_MODES[0].placeholder;

  const handleSearch = () => {
    const trimmed = value.trim();
    if (trimmed) onSearch(trimmed);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className='bg-white rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <div className='flex flex-wrap items-center justify-between gap-3 mb-3 px-1'>
        <label className='text-[13px] font-bold text-gray-400 uppercase tracking-widest block'>
          Buscar pedido
        </label>
        {onModeChange && (
          <div className='inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50'>
            {SEARCH_MODES.map((option) => (
              <button
                key={option.value}
                type='button'
                onClick={() => onModeChange(option.value)}
                className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
                  mode === option.value
                    ? 'bg-white shadow-sm font-semibold text-gray-900'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className='flex gap-3 items-stretch' onKeyDown={handleKeyDown}>
        <TextInput
          name='amendment-shipping-search'
          placeholder={placeholder}
          value={value}
          onChange={(v) => setValue(v.toString())}
          autoFocus
        />
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={handleSearch}
          disabled={!value.trim() || isLoading}
          sx={{ whiteSpace: 'nowrap', alignSelf: 'stretch' }}
        >
          <SearchIcon />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default ShippingSearchInput;
